
 import request from 'superagent';
 import baseRequest from '../baseApi';
 
 // 获取落地页数据数据
 export const fetchGetpaddlenlp = (): Promise<request.Response> =>
     baseRequest(
         request.get('/platform/page/data')
             .query({requestUrl: '/paddleNLP'})
             .query(window.location.search.slice(1))
     );
 